import { SvgIcon, SvgIconProps } from '@mui/material';
import useTheme from '@mui/material/styles/useTheme';

export const IllustrationTree = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon
      style={{ fill: 'none', ...props.style }}
      data-testid="IllustrationTree"
      {...props}>
      <g clip-path="url(#clip0_4977_54901)">
        <path
          d="M149.094 298.585C175.487 266.733 201.875 234.885 228.268 203.033"
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M32.4492 108.502L135.519 208.394"
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M66.1348 108.502L57 132.294"
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M224.373 132.294L148.504 222.359"
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M181.211 129.422L210.422 149.322"
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M56.0088 36.5525H44.9549C42.501 36.5525 40.5117 38.5418 40.5117 40.9957V76.8531C40.5117 79.307 42.501 81.2963 44.9549 81.2963H56.0088C58.4628 81.2963 60.452 79.307 60.452 76.8531V40.9957C60.452 38.5418 58.4628 36.5525 56.0088 36.5525Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M50.4996 29.6663H52.5181C53.8592 29.6663 54.9519 30.7545 54.9519 32.1001V36.5524H48.0703V32.1001C48.0703 30.759 49.1585 29.6663 50.5042 29.6663H50.4996Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M52.9609 24.9973H50.0078V29.6663H52.9609V24.9973Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M44.1523 26.1488L47.4712 24.9973H53.2736"
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M40.5117 48.3467H60.4475"
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M43.2031 68.6714H60.4477"
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M125.91 95.1863L131.875 84.8548C133.265 82.4436 131.527 79.4272 128.741 79.4272H102.172C99.3859 79.4272 97.6429 82.4436 99.0382 84.8548L105.084 95.3262C101.499 98.329 99.2188 102.835 99.2188 107.879C99.2188 116.919 106.547 124.243 115.583 124.243C124.618 124.243 131.947 116.915 131.947 107.879C131.947 102.759 129.594 98.189 125.91 95.1863ZM104.29 86.8371C103.463 85.5954 104.294 83.875 105.721 83.875H125.187C126.614 83.875 127.445 85.5954 126.619 86.8371L122.496 93.0459C120.396 92.0661 118.053 91.5107 115.578 91.5107C113.104 91.5107 110.616 92.0932 108.466 93.1317L104.285 86.8371H104.29Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M126.941 389.902H152.883L143.156 46.749L126.941 389.902Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M130.63 150.017C127.13 150.017 123.911 151.205 121.341 153.192C119.44 146.969 113.652 142.44 106.802 142.44C104.07 142.44 101.505 143.167 99.2879 144.427C96.6644 136.809 89.4351 131.337 80.928 131.337C71.2603 131.337 63.2408 138.403 61.7552 147.656C59.4885 146.315 56.8514 145.542 54.0293 145.542C45.635 145.542 38.8257 152.347 38.8257 160.746C38.8257 161.626 38.9024 162.484 39.0469 163.324C35.2585 164.259 32.4453 167.668 32.4453 171.741C32.4453 176.537 36.3331 180.42 41.1241 180.42C41.3679 180.42 41.6072 180.402 41.842 180.384V180.42H130.621C139.015 180.42 145.824 173.615 145.824 165.216C145.824 156.818 139.02 150.013 130.621 150.013L130.63 150.017Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M124.083 152.821C120.583 152.821 117.364 154.009 114.795 155.996C112.894 149.773 107.105 145.244 100.255 145.244C97.5229 145.244 94.9581 145.971 92.741 147.231C90.1175 139.614 82.8882 134.141 74.3811 134.141C64.7134 134.141 56.694 141.208 55.2084 150.46C52.9416 149.119 50.3046 148.347 47.4824 148.347C39.0881 148.347 32.2788 155.151 32.2788 163.55C32.2788 164.431 32.3556 165.289 32.5001 166.128C28.7116 167.063 25.8984 170.472 25.8984 174.545C25.8984 179.341 29.7863 183.224 34.5772 183.224C34.821 183.224 35.0603 183.206 35.2951 183.188V183.224H124.074C132.468 183.224 139.277 176.419 139.277 168.02C139.277 159.622 132.473 152.817 124.074 152.817L124.083 152.821Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M209.955 40.3544C208.559 40.3544 207.196 40.4943 205.882 40.7653C206.193 39.3519 206.36 37.8889 206.36 36.3807C206.36 25.1824 197.28 16.1017 186.081 16.1017C181.186 16.1017 176.698 17.8357 173.199 20.7211C170.543 9.23822 160.257 0.672363 147.966 0.672363C135.675 0.672363 125.592 9.06663 122.81 20.3779C116.773 20.8249 111.684 24.6857 109.481 30.041C106.618 28.4967 103.344 27.6162 99.8628 27.6162C88.6644 27.6162 79.5838 36.6968 79.5838 47.8952C79.5838 48.9789 79.6696 50.04 79.8321 51.0741C72.1649 51.7108 66.1367 58.1273 66.1367 65.9616C66.1367 74.2159 72.8286 80.9033 81.0784 80.9033H209.48V80.8898C209.638 80.8898 209.797 80.9033 209.955 80.9033C221.153 80.9033 230.234 71.8227 230.234 60.6243C230.234 49.4259 221.153 40.3453 209.955 40.3453V40.3544Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M198.787 44.2967C197.391 44.2967 196.028 44.4367 194.714 44.7076C195.025 43.2943 195.192 41.8313 195.192 40.3231C195.192 29.1247 186.112 20.0441 174.913 20.0441C170.018 20.0441 165.53 21.7781 162.031 24.6634C159.376 13.1806 149.089 4.61475 136.798 4.61475C124.507 4.61475 114.424 13.009 111.642 24.3203C105.605 24.7673 100.516 28.628 98.3128 33.9834C95.45 32.4391 92.1762 31.5586 88.6948 31.5586C77.4964 31.5586 68.4158 40.6392 68.4158 51.8376C68.4158 52.9213 68.5016 53.9824 68.6642 55.0165C60.9969 55.6531 54.9688 62.0696 54.9688 69.904C54.9688 78.1583 61.6607 84.8457 69.9105 84.8457H198.312V84.8321C198.47 84.8321 198.629 84.8457 198.787 84.8457C209.985 84.8457 219.066 75.7651 219.066 64.5667C219.066 53.3683 209.985 44.2877 198.787 44.2877V44.2967Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M78.3414 88.4488C77.6505 88.4488 76.9777 88.5166 76.3275 88.652C76.481 87.9521 76.5668 87.2297 76.5668 86.4846C76.5668 80.9486 72.0784 76.4557 66.5379 76.4557C64.1176 76.4557 61.9005 77.3137 60.1666 78.7406C58.8526 73.0601 53.7682 68.8291 47.6903 68.8291C41.6125 68.8291 36.6274 72.9788 35.2502 78.5735C32.2655 78.7948 29.7504 80.7048 28.6576 83.3509C27.2443 82.5878 25.6232 82.1543 23.9028 82.1543C18.3668 82.1543 13.8739 86.6426 13.8739 92.1831C13.8739 92.7205 13.9191 93.2443 13.9959 93.7545C10.2029 94.0706 7.22266 97.245 7.22266 101.115C7.22266 105.197 10.5325 108.502 14.61 108.502H78.102C78.1788 108.502 78.2601 108.502 78.3368 108.502C83.8728 108.502 88.3657 104.014 88.3657 98.4732C88.3657 92.9327 83.8773 88.4443 78.3368 88.4443L78.3414 88.4488Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M71.7906 88.4488C71.0997 88.4488 70.4269 88.5166 69.7767 88.652C69.9302 87.9521 70.016 87.2297 70.016 86.4846C70.016 80.9486 65.5276 76.4557 59.9871 76.4557C57.5668 76.4557 55.3497 77.3137 53.6158 78.7406C52.3018 73.0601 47.2174 68.8291 41.1395 68.8291C35.0617 68.8291 30.0766 72.9788 28.6994 78.5735C25.7147 78.7948 23.1996 80.7048 22.1068 83.3509C20.6935 82.5878 19.0724 82.1543 17.352 82.1543C11.8161 82.1543 7.32317 86.6426 7.32317 92.1831C7.32317 92.7205 7.36832 93.2443 7.44509 93.7545C3.65209 94.0706 0.671875 97.245 0.671875 101.115C0.671875 105.197 3.98172 108.502 8.05919 108.502H71.5513C71.628 108.502 71.7093 108.502 71.7861 108.502C77.322 108.502 81.8149 104.014 81.8149 98.4732C81.8149 92.9327 77.3265 88.4443 71.7861 88.4443L71.7906 88.4488Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M264.127 99.0189C263.238 99.0189 262.366 99.1001 261.517 99.2446C260.158 92.2411 253.999 86.949 246.598 86.949C245.849 86.949 245.108 87.0077 244.39 87.1116C239.938 76.1977 229.223 68.4988 216.706 68.4988C205.656 68.4988 196.016 74.4998 190.841 83.4134C188.371 82.2032 185.599 81.5214 182.664 81.5214C172.391 81.5214 164.064 89.8479 164.064 100.121C164.064 102.654 164.575 105.07 165.491 107.273C160.447 108.366 156.668 112.85 156.668 118.219C156.668 124.405 161.685 129.422 167.871 129.422H264.123C272.517 129.422 279.326 122.617 279.326 114.218C279.326 105.819 272.521 99.0143 264.123 99.0143L264.127 99.0189Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M256.549 101.891C255.66 101.891 254.788 101.973 253.939 102.117C252.58 95.1137 246.421 89.8216 239.02 89.8216C238.27 89.8216 237.53 89.8803 236.812 89.9841C232.36 79.0702 221.644 71.3713 209.128 71.3713C198.078 71.3713 188.438 77.3724 183.263 86.2859C180.793 85.0758 178.02 84.394 175.085 84.394C164.813 84.394 156.486 92.7205 156.486 102.993C156.486 105.526 156.996 107.942 157.913 110.146C152.869 111.238 149.09 115.722 149.09 121.091C149.09 127.277 154.107 132.294 160.293 132.294H256.545C264.939 132.294 271.748 125.489 271.748 117.091C271.748 108.692 264.943 101.887 256.545 101.887L256.549 101.891Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M75.9453 183.224C95.2083 202.32 114.476 221.411 133.739 240.507"
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M175.157 238.913C178.501 238.913 181.212 234.258 181.212 228.514C181.212 222.771 178.501 218.115 175.157 218.115C171.813 218.115 169.102 222.771 169.102 228.514C169.102 234.258 171.813 238.913 175.157 238.913Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M181.212 244.816C186.509 244.816 190.803 237.439 190.803 228.339C190.803 219.239 186.509 211.862 181.212 211.862C175.915 211.862 171.621 219.239 171.621 228.339C171.621 237.439 175.915 244.816 181.212 244.816Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M186.442 244.991C191.739 244.991 196.033 237.614 196.033 228.514C196.033 219.414 191.739 212.037 186.442 212.037C181.146 212.037 176.852 219.414 176.852 228.514C176.852 237.614 181.146 244.991 186.442 244.991Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M232.255 227.16H186.441V231.676H232.255V227.16Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M227.919 244.991C233.216 244.991 237.51 237.614 237.51 228.514C237.51 219.414 233.216 212.037 227.919 212.037C222.622 212.037 218.328 219.414 218.328 228.514C218.328 237.614 222.622 244.991 227.919 244.991Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M232.255 244.991C237.552 244.991 241.846 237.614 241.846 228.514C241.846 219.414 237.552 212.037 232.255 212.037C226.958 212.037 222.664 219.414 222.664 228.514C222.664 237.614 226.958 244.991 232.255 244.991Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M233.973 238.913C237.317 238.913 240.028 234.257 240.028 228.514C240.028 222.771 237.317 218.115 233.973 218.115C230.629 218.115 227.918 222.771 227.918 228.514C227.918 234.257 230.629 238.913 233.973 238.913Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M236.711 238.913C240.056 238.913 242.767 234.258 242.767 228.514C242.767 222.771 240.056 218.115 236.711 218.115C233.367 218.115 230.656 222.771 230.656 228.514C230.656 234.258 233.367 238.913 236.711 238.913Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M104.848 273.832H111.246V299.34C111.246 300.157 110.582 300.816 109.77 300.816H106.324C105.507 300.816 104.848 300.152 104.848 299.34V273.832Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M111.246 265.532H104.848V295.714H111.246V265.532Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M83.9727 304.013H90.3711V329.521C90.3711 330.338 89.7073 330.998 88.8945 330.998H85.4492C84.6319 330.998 83.9727 330.334 83.9727 329.521V304.013Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M90.3711 295.714H83.9727V325.896H90.3711V295.714Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M108.346 264.71C108.54 256.099 108.73 247.484 108.468 238.868C108.206 230.339 107.493 221.804 105.908 213.41C105.235 209.865 104.598 205.666 101.32 203.53C99.9293 202.623 98.1502 202.279 96.5743 202.889C94.9984 203.499 93.8966 204.695 93.2058 206.131C92.3614 207.879 92.2304 209.847 92.3343 211.757C92.4517 213.911 92.7317 216.061 92.9484 218.205C93.3864 222.576 93.8289 226.947 94.2669 231.318C94.7094 235.725 95.1565 240.137 95.599 244.544C95.7931 246.486 96.0776 248.437 96.1363 250.387C96.177 251.742 96.1183 253.236 95.4951 254.469C94.8404 255.765 93.4993 256.515 92.0453 256.162C90.3565 255.756 88.9748 254.356 87.9724 253.006C85.814 250.103 84.2155 246.689 83.0821 243.262C80.8018 236.349 80.4631 228.794 82.2964 221.737C82.5357 220.811 83.6872 218.187 84.7709 219.908C85.254 220.671 85.534 221.606 85.823 222.454C86.1345 223.371 86.401 224.301 86.6222 225.241C87.5479 229.115 87.7511 233.116 87.7014 237.085C87.6517 241.054 87.3312 245.303 87.1099 249.407C86.8751 253.783 86.69 258.158 86.55 262.534C86.27 271.325 86.1842 280.126 86.2836 288.922C86.3107 291.094 86.3468 293.266 86.3964 295.434C86.4145 296.305 87.7692 296.305 87.7511 295.434C87.5524 286.452 87.5479 277.462 87.7466 268.481C87.9407 259.635 88.4329 250.812 88.8845 241.979C89.0922 237.925 89.196 233.843 88.758 229.797C88.5413 227.814 88.2071 225.841 87.6834 223.913C87.4215 222.947 87.1144 221.989 86.7532 221.055C86.4461 220.246 86.1481 219.343 85.5475 218.698C84.3238 217.379 82.6621 218.106 81.8087 219.402C80.874 220.82 80.6257 222.734 80.3457 224.369C79.7135 228.031 79.6007 231.774 80.0116 235.468C80.427 239.162 81.3301 242.792 82.7434 246.233C83.4478 247.949 84.2606 249.615 85.2044 251.214C86.1481 252.812 87.137 254.356 88.4916 255.598C89.7198 256.727 91.3364 257.725 93.0703 257.594C94.5785 257.481 95.8925 256.591 96.6059 255.268C98.2044 252.315 97.351 248.473 97.0349 245.321C96.1318 236.353 95.2287 227.385 94.3256 218.418C94.1044 216.232 93.8244 214.042 93.6935 211.848C93.5806 209.933 93.6664 207.91 94.6869 206.226C95.5177 204.853 96.9356 203.788 98.6018 203.932C100.367 204.086 101.821 205.436 102.652 206.917C103.627 208.646 103.989 210.656 104.373 212.579C104.802 214.719 105.167 216.873 105.483 219.032C106.116 223.362 106.535 227.724 106.806 232.091C107.348 240.832 107.299 249.602 107.127 258.353C107.086 260.466 107.037 262.584 106.992 264.697C106.973 265.568 108.328 265.568 108.346 264.697V264.71Z"
          fill="currentColor"
        />
        <path
          d="M172.142 180.058C172.837 180.058 173.519 180.122 174.183 180.235C175.244 174.757 180.062 170.621 185.846 170.621C186.433 170.621 187.011 170.666 187.576 170.748C191.057 162.213 199.433 156.199 209.218 156.199C217.857 156.199 225.393 160.89 229.439 167.858C231.367 166.909 233.539 166.377 235.833 166.377C243.861 166.377 250.372 172.888 250.372 180.916C250.372 182.899 249.975 184.786 249.257 186.511C253.199 187.365 256.152 190.869 256.152 195.068C256.152 199.904 252.233 203.823 247.397 203.823H172.146C165.581 203.823 160.262 198.504 160.262 191.939C160.262 185.373 165.581 180.054 172.146 180.054L172.142 180.058Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M163.314 180.731C164.009 180.731 164.691 180.794 165.355 180.907C166.416 175.43 171.234 171.294 177.018 171.294C177.605 171.294 178.183 171.339 178.748 171.42C182.229 162.886 190.605 156.871 200.39 156.871C209.028 156.871 216.565 161.563 220.611 168.53C222.539 167.582 224.711 167.049 227.005 167.049C235.033 167.049 241.544 173.561 241.544 181.589C241.544 183.571 241.147 185.459 240.429 187.184C244.371 188.037 247.324 191.541 247.324 195.741C247.324 200.577 243.405 204.496 238.569 204.496H163.318C156.753 204.496 151.434 199.177 151.434 192.611C151.434 186.046 156.753 180.727 163.318 180.727L163.314 180.731Z"
          fill={theme.palette.background.default}
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
        <path
          d="M70.9805 222.36H115.435"
          stroke="currentColor"
          strokeWidth="1.35464"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_4977_54901">
          <rect width="280" height="390.579" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};
